module.exports = {
  sanity: {
    projectId: "uutfmquc",
    dataset: "production",
    useCdn: true
  },
};
